import React, { memo } from 'react'

const Holiday = memo(({ grid, slot }) => {
  if (!slot.firstHoliday) return null
  const rowCount = grid.length
  const className =
    slot.holidayCount >= rowCount / 2
      ? 'atp-time-list__holiday atp-time-list__holiday--full-day'
      : 'atp-time-list__holiday'

  return (
    <li className={className}>
      <div className="atp-time-list__holiday__label">{slot.holidayName}</div>
    </li>
  )
})
Holiday.displayName = 'Holiday'

export default Holiday
